class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const containerModal = document.getElementById('ProductCountModal');
    if (containerModal) {
      containerModal.innerHTML = count;
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    if (mobileForm) {
      const drawer = mobileForm.closest('menu-drawer');
      if (drawer && typeof drawer.bindEvents === 'function') drawer.bindEvents();
    }
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    });
  }
}

customElements.define('facet-remove', FacetRemove);

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.numberInputs = Array.from(this.querySelectorAll('input[type="number"]'));
    this.sliderInputs = Array.from(this.querySelectorAll('input[type="range"]'));

    this.numberInputs.forEach((element) => {
      element.addEventListener('change', this.onNumberChange.bind(this));
      element.addEventListener('input', this.onNumberChange.bind(this));
    });

    this.sliderInputs.forEach((element) => {
      element.addEventListener('input', (e) => {
        e.stopPropagation();
        this.onSliderInput(e);
      });
      element.addEventListener('change', this.onSliderChange.bind(this));
    });

    this.setMinAndMaxValues();
    this.syncSliderFromNumbers();
  }

  onNumberChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
    this.syncSliderFromNumbers();
  }

  onSliderInput(event) {
    if (this.numberInputs.length < 2 || this.sliderInputs.length < 2) return;

    const minInput = this.numberInputs[0];
    const maxInput = this.numberInputs[1];
    const minSlider = this.sliderInputs[0];
    const maxSlider = this.sliderInputs[1];
    const sliderMin = Number(minSlider.min || 0);
    const sliderMax = Number(minSlider.max || maxSlider.max || 0);
    const currentMin = Number(minSlider.value || 0);
    const currentMax = Number(maxSlider.value || sliderMax);

    if (event.currentTarget === minSlider && currentMin > currentMax) {
      minSlider.value = currentMax;
    }

    if (event.currentTarget === maxSlider && currentMax < currentMin) {
      maxSlider.value = currentMin;
    }

    minInput.value = minSlider.value;
    maxInput.value = maxSlider.value;
    minInput.min = sliderMin;
    maxInput.max = sliderMax;

    this.setMinAndMaxValues();
    this.updateSliderProgress();
  }

  onSliderChange(event) {
    this.onSliderInput(event);
    if (this.numberInputs.length > 0) {
      this.numberInputs[0].dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  setMinAndMaxValues() {
    if (this.numberInputs.length < 2) return;

    const minInput = this.numberInputs[0];
    const maxInput = this.numberInputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  syncSliderFromNumbers() {
    if (this.numberInputs.length < 2 || this.sliderInputs.length < 2) return;

    const minInput = this.numberInputs[0];
    const maxInput = this.numberInputs[1];
    const minSlider = this.sliderInputs[0];
    const maxSlider = this.sliderInputs[1];

    const sliderMin = Number(minSlider.min || 0);
    const sliderMax = Number(minSlider.max || maxSlider.max || 0);

    const minValue = minInput.value === '' ? sliderMin : Number(minInput.value);
    const maxValue = maxInput.value === '' ? sliderMax : Number(maxInput.value);
    const clampedMin = Math.min(Math.max(minValue, sliderMin), sliderMax);
    const clampedMax = Math.min(Math.max(maxValue, sliderMin), sliderMax);

    minSlider.value = Math.min(clampedMin, clampedMax);
    maxSlider.value = Math.max(clampedMax, clampedMin);

    this.updateSliderProgress();
  }

  updateSliderProgress() {
    if (this.sliderInputs.length < 2) return;

    const minSlider = this.sliderInputs[0];
    const maxSlider = this.sliderInputs[1];
    const sliderMin = Number(minSlider.min || 0);
    const sliderMax = Number(minSlider.max || 0);
    const sliderRange = sliderMax - sliderMin || 1;
    const start = ((Number(minSlider.value) - sliderMin) / sliderRange) * 100;
    const end = ((Number(maxSlider.value) - sliderMin) / sliderRange) * 100;
    const slider = this.querySelector('[data-range-slider]');

    if (slider) {
      slider.style.setProperty('--range-start', `${start}%`);
      slider.style.setProperty('--range-end', `${end}%`);
    }
  }
}

customElements.define('price-range', PriceRange);
